// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import Logo from 'components/logo';
import DrawerHeaderStyled from './DrawerHeaderStyled';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import IconButton from '@mui/material/IconButton';
import { handlerDrawerOpen } from 'api/menu';
import { MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';

interface Props {
  open: boolean;
}

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }: Props) {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const { menuOrientation } = useConfig();
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: isHorizontal ? 'unset' : '60px',
        width: isHorizontal ? { xs: '100%', lg: '424px' } : 'initial',
        paddingTop: isHorizontal ? { xs: '10px', lg: '0' } : open ? '20px' : '60px',
        paddingBottom: isHorizontal ? { xs: '18px', lg: '0' } : '20px',
        paddingLeft: isHorizontal ? { xs: '24px', lg: '0' } : open ? '24px' : 0
      }}
    >
      <Logo isIcon={!open} sx={{ width: open ? 'auto' : 32, height: 32 }} logoSize={32} fontSize={16} to="/restaurant" />
      <IconButton
        size="small"
        sx={{
          position: 'absolute',
          right: open ? -14 : 15,
          top: open ? 20 : 12,
          borderRadius: '50%',
          border: '1px solid',
          borderColor: 'text.secondary',
          bgcolor: 'background.paper',
          zIndex: 1000,
          '& .anticon': {
            fontSize: 14,
            color: 'text.secondary'
          }
        }}
        onClick={() => handlerDrawerOpen(!open)}
      >
        {open ? <LeftOutlined /> : <RightOutlined />}
      </IconButton>
    </DrawerHeaderStyled>
  );
}
